class Ticket {
  constructor() {
    this.ticketNo = ''
    this.eicLogin = ''
  }
}

export { Ticket }
